export const ADMIN_AUTH_EXPIRED_EVENT = 'docusense:admin-auth-expired' as const;

export interface AdminStoredToken {
  accessToken: string;
  expiresAtMs: number;
}

let current: AdminStoredToken | null = null;

export const AdminTokenStore = {
  get(): AdminStoredToken | null {
    return current;
  },
  set(token: AdminStoredToken): void {
    current = token;
  },
  clear(): void {
    current = null;
  },
  isValid(nowMs: number = Date.now()): boolean {
    return current !== null && current.expiresAtMs > nowMs;
  },
};
